<div class="device-ids-filter">
  <button
    class="datatable-search__button"
    mat-icon-button
    matTooltip="Search"
    (click)="onClick()"
    [color]="showSearch ? 'accent' : 'primary'"
  >
    <mat-icon [matBadge]="!showSearch && deviceIdsStringList() ? '...' : ''" matBadgeColor="accent"
      >search</mat-icon
    >
  </button>
  <div class="container">
    @if (showSearch) {
      <mat-form-field
        appearance="outline"
        class="top-row filter-field small-form-field small-icon-button-wrapper"
      >
        <mat-label>Device IDs (comma separated)</mat-label>
        <input matInput [ngModel]="deviceIdsStringList()" (ngModelChange)="onChangeValue($event)" />
        @if (deviceIdsStringList()) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="onReset()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
</div>
